const DEFAULT_COOKIE = 'MC-CSRF';

export const getCookie = (name) => {
  if (typeof document === 'undefined') {
    return '';
  }
  const target = `${name}=`;
  const parts = document.cookie.split(';');
  for (const part of parts) {
    const trimmed = part.trim();
    if (trimmed.startsWith(target)) {
      return decodeURIComponent(trimmed.substring(target.length));
    }
  }
  return '';
};

export const getCsrfToken = () => {
  const cookieName = window.__CB_CONFIG__?.csrfCookieName || DEFAULT_COOKIE;
  return getCookie(cookieName);
};

export const ensureCsrfToken = async () => {
  const existing = getCsrfToken();
  if (existing) return existing;

  await fetch('/config.js', {
    credentials: 'include',
    cache: 'no-store',
    headers: {
      Accept: 'application/javascript, text/javascript, */*',
      'X-Requested-With': 'XMLHttpRequest',
    },
  }).catch(() => null);

  return getCsrfToken();
};

export default getCsrfToken;
